export default __webpack_public_path__ + "static/commonwealth_brandstudio_web_logo-4bcc0ce4b002a25a8951c9957675d8e2.svg";